import { CHANNEL as CHANNEL_CONSTANT } from '@boss/constants/b2b-b2c';
import { IconDefinition } from '@fortawesome/free-brands-svg-icons';
import { ReactNode } from 'react';

import AccordionPrimary from './Primary';
import AccordionSecondary from './Secondary';
import AccordionSimple from './Simple';

export interface IAccordionProps {
  title: ReactNode;
  children: ReactNode;
  iconClassName?: string;
  variant?: 'primary' | 'secondary' | 'simple';
  hasVideo?: boolean;
  solid?: boolean;
  className?: string;
  buttonClassName?: string;
  closedIcon?: IconDefinition;
  expandedIcon?: IconDefinition;
  titleClassName?: string;
  isOpen?: boolean;
  ariaLabel?: string;
  testId?: string;
  hideDivider?: boolean;
  noIndent?: boolean;
  progressiveRender?: boolean;
  wrapperClassName?: string;
  setExpanded?: (isOpen: boolean) => void;
  iconPosition?: 'left' | 'right';
  channel?: string;
}

const Accordion = ({ variant = 'primary', ...props }: IAccordionProps) => {
  // NOTE: The dom signature of both variants is almost equal, aggregate and simplify
  // This is bad for maintainability
  // TODO: Mark for refactor

  const channel = props.channel ?? CHANNEL_CONSTANT;

  if (variant === 'primary') {
    return <AccordionPrimary {...props} />;
  }
  // NOTE: This is a very verbose, badly manageable way of passing a boolean value (i.e. solid)
  // TODO: Simplify
  if (variant === 'secondary' && channel === 'colora') {
    return <AccordionSecondary {...props} />;
  }
  if (variant === 'secondary' && channel === 'boss-paints') {
    return <AccordionSecondary solid={true} {...props} />;
  }
  if (variant === 'simple') {
    return <AccordionSimple {...props} />;
  }
  return null;
};

export default Accordion;
